import {
  ChangeDetectorRef,
  Component,
  inject,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MenuItemComponent } from '../menu-item/menu-item.component';
import { MatIconModule } from '@angular/material/icon';
import { DropdownDirective } from '../../../directives/DropDown/dropdown.directive';
import { StorageService } from '../../../services/storage.service';
import { ViewPath } from '../../../constants/ViewPath';
import { CommonModule } from '@angular/common';
import { MenuItemInterface, MenuOption, MenuService } from '../../../services/menu.service';
import { IMenuComponent } from '../../../interfaces/IMenuComponent';

export enum MultipleMenuSection {
  CLIENTES = 1,
  MONITORING = 2,
  DEVELOPER = 3,
}

@Component({
  selector: 'app-multiple-menu-item',
  templateUrl: './multiple-menu-item.component.html',
  styleUrls: ['./multiple-menu-item.component.css'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatIconModule, CommonModule, MenuItemComponent, DropdownDirective],
})
export class MultipleMenuItemComponent {
  @ViewChildren('menuItemRef') children?: QueryList<any>;
  @ViewChild(DropdownDirective) dropdownDirective?: DropdownDirective;

  @Input({ required: true }) id!: string;
  @Input({ required: true }) data!: MenuItemInterface;
  @Input({ required: true }) parent!: IMenuComponent;
  @Input() class_?: string;

  // Constructor (inyeccion de dependencias de angular, ultimas recomendaciones)
  chdRef = inject(ChangeDetectorRef);
  menuS = inject(MenuService);
  storageS = inject(StorageService);

  ngAfterViewInit() {
    if (!this.children) {
      return;
    }
    this.initToggleFromStorage();
    this.chdRef.detectChanges();
    this.parent.onStartOnboardingSection.subscribe((v) => {
      if (this.dropdownDirective) {
        this.dropdownDirective.openIfClosed();
      }
    });
  }

  initToggleFromStorage() {
    if (this.dropdownDirective && !this.isStorageOpen()) {
      this.dropdownDirective.toggle();
      this.chdRef.detectChanges();
    }
  }

  getClass() {
    return this.someChildSelected ? 'burgerSelected' : '';
  }

  getBadge(menuOption: MenuOption) {
    return undefined;
  }

  getSvgIcon(menuOption: MenuOption) {
    return menuOption.icon == 'wheel';
  }

  saveToggle(opened: boolean) {
    this.storageS.save('menu-item-' + this.id.toString(), opened);
  }

  isStorageOpen() {
    let toggled = this.storageS.getBoolean('menu-item-' + this.id.toString());
    return toggled == null ? true : toggled;
  }

  /** Return array of MenuOption from the children array */
  get childsToBurger(): MenuOption[] {
    if (!this.children) {
      return [];
    }
    return this.children.map((item) => item.data);
  }

  /** Is some child showing ? */
  get someChildShowing() {
    if (!this.children) {
      return false;
    }
    return this.menuS.childsHasPermission(this.childsToBurger);
  }

  /** Is some child selected ? */
  get someChildSelected() {
    if (!this.children) {
      return false;
    }
    return this.menuS.isSelectedMultiple(this.childsToBurger) ? 'burgerSelected' : '';
  }

  get totalChildsShowing(): number {
    if (!this.children) {
      return 0;
    }
    return this.children.reduce((total, ch) => (ch.isShowing ? total + 1 : total), 0);
  }
}
